/** Розмір ігрового поля у клітинках (включно з рамкою). */
export const COLS = 31;
export const ROWS = 13;
/** Розмір клітинки у пікселях (логічний 16, 2× для рендера). */
export const TILE = 32;
/** Загальний розмір canvas. */
export const W = COLS * TILE;
export const H = ROWS * TILE;
/** Фіксований ігровий тік: 60 Гц. */
export const TICK_MS = 1000 / 60;
/** Скільки тіків горить фьюз бомби до вибуху (≈2 сек на 60 Гц). */
export const FUSE_TICKS = 120;
/** Скільки тіків живе клітинка полум'я після вибуху (≈0.5 сек). */
export const FLAME_TICKS = 30;
